import React from "react";

import Weather from "components/weather/Weather";
import { SkeletonBar } from "components/skeleton";
import { TWeather } from "redux/reducers/models/facility";

interface ITeesheetDateWeatherProps {
  weather: TWeather | null;
}

export default function TeesheetDateWeather(props: ITeesheetDateWeatherProps) {
  if (!props.weather) {
    return (
      <SkeletonBar
        className="teesheet-date-weather-skeleton"
        height="1.5rem"
      />
    );
  }

  return <Weather weather={props.weather} />;
}
